import React from "react";
//Limitless impirts
import { useNotificationContext } from "@limitless/common/hooks/notification/NotificationContext";
import { useAuthenticationContext } from "../../../expert/hooks/authentication/AuthenticationContext";
import { getDateForTimeZone } from "@limitless/common/utils/date-utils/DateUtils";
import { getManagerProfileStorageKey } from "@limitless/common/utils";
const INITIAL_STATE = {
  timeZone: {
    name: "UTC (UTC)",
    value: "UTC"
  },
  showSystemDialogues: false,
  showNonProdGroups: false,
  showPlatformLabels: false,
  showDevDateTime: false,
  loading: true,
  disableChanges: true,
  messages: {}
};
const NOTIFICATION_MAP = {
  showSystemDialogues: {
    on: "System Dialogues are now visible",
    off: "System Dialogues are now hidden"
  },
  showNonProdGroups: {
    on: "Non-Production Groups now shown",
    off: "Non-Production Groups now hidden"
  },
  showPlatformLabels: {
    on: "Database Metric names now shown",
    off: "Pretty Metric names now shown"
  },
  showDevDateTime: {
    on: "Developer date times now shown",
    off: "Developer date times now hidden"
  }
};
const MANAGER_PROFILE_STORAGE_KEY = getManagerProfileStorageKey();
const UPDATE_MANAGER_PROFILE = "update-manager-profile";
const TOGGLE_DISABLE_CHANGE = "toggle-block-change";
const managerProfileReducer = (state, action) => {
  switch (action.type) {
    case UPDATE_MANAGER_PROFILE:
      return {
        ...state,
        ...action.payload,
        disableChanges: false
      };
    case TOGGLE_DISABLE_CHANGE:
      return {
        ...state,
        disableChanges: !state.disableChanges
      };
    default:
      throw new Error(`Unsupported manager profile action type ${action.tyoe}`);
  }
};
export const useManagerProfile = () => {
  const [managerProfile, dispatch] = React.useReducer(managerProfileReducer, INITIAL_STATE);
  const {
    addSuccessNotification,
    addFailureNotification
  } = useNotificationContext();
  const {
    isAuthenticated
  } = useAuthenticationContext();
  React.useEffect(() => {
    if (isAuthenticated) {
      loadManagerProfile();
    }
  }, [isAuthenticated]);
  React.useEffect(() => {
    if (!managerProfile.loading) {
      window.localStorage[MANAGER_PROFILE_STORAGE_KEY] = JSON.stringify(managerProfile);
    }
  }, [managerProfile, Object.keys(managerProfile.messages).length, managerProfile.showDevDateTime]);
  const loadManagerProfile = () => {
    if (window.localStorage[MANAGER_PROFILE_STORAGE_KEY]) {
      try {
        const localManagerProfile = JSON.parse(window.localStorage[MANAGER_PROFILE_STORAGE_KEY]);
        dispatch({
          type: UPDATE_MANAGER_PROFILE,
          payload: {
            ...localManagerProfile,
            loading: false
          }
        });
      } catch (error) {
        addFailureNotification("Local manager profile is corrupt, defaults will be used.");
        dispatch({
          type: UPDATE_MANAGER_PROFILE,
          payload: {
            loading: false
          }
        });
      }
    } else {
      dispatch({
        type: UPDATE_MANAGER_PROFILE,
        payload: {
          loading: false
        }
      });
    }
  };
  const updateManagerTimeZone = timeZone => {
    dispatch({
      type: UPDATE_MANAGER_PROFILE,
      payload: timeZone
    });
    addSuccessNotification(`Time Zone updated to ${timeZone.value}`);
  };
  const updateBooleanProperty = (key, value) => {
    const successMessage = NOTIFICATION_MAP[key][value === true ? "on" : "off"];
    dispatch({
      type: UPDATE_MANAGER_PROFILE,
      payload: {
        [key]: value
      }
    });
    addSuccessNotification(successMessage, "Update App Settings");
  };
  const updateManagerProfile = newValues => {
    dispatch({
      type: UPDATE_MANAGER_PROFILE,
      payload: newValues
    });
  };
  const toggleDisableProfileChanges = () => {
    dispatch({
      type: TOGGLE_DISABLE_CHANGE
    });
  };
  const getManagerTime = time => {
    return getDateForTimeZone(time, managerProfile.timeZone);
  };
  return {
    managerProfile,
    updateManagerTimeZone,
    updateBooleanProperty,
    updateManagerProfile,
    getManagerTime,
    toggleDisableProfileChanges
  };
};